Vue.component('navigation-toggler', require('./../src/components/Navigation/Toggler'));
Vue.component('navigation-wrapper', require('./../src/components/Navigation/Wrapper'));

Vue.component('cookie-consent', require('./../src/components/Cookie/CookieConsent'));
Vue.component('cookie-setup', require('./../src/components/Cookie/CookieSetup'));
Vue.component('share-buttons', require('./../src/components/ShareButtons'));
Vue.component('search-form', require('./../src/components/Search/SearchForm'));
Vue.component('search-trigger', require('./../src/components/Search/SearchTrigger'));
Vue.component('ssd-paginator', require('./../src/components/Paginator/Select'));

Vue.component('change-reveal', require('./../src/components/Reveal/Change'));
Vue.component('toggle-reveal', require('./../src/components/Reveal/Toggle'));
Vue.component('accordion', require('./../src/components/Reveal/Accordion'));
Vue.component('image-highlight', require('./../src/components/Reveal/ImageHighlight'));
Vue.component('mapbox-map', require('./../src/components/Map/MapboxMap'));

Vue.component('captcha', require('./../src/components/Widget/Captcha'));



// WEBPACK FOOTER //
// ./resources/js/front/components.js